/* eslint-disable */
export enum CHARTS_DATA_ACTION_TYPES {
	GET_CHARTS_DATA = 'GET_CHARTS_DATA',
	GET_PAIN_LEVEL_CHART_DATA = 'GET_PAIN_LEVEL_CHART_DATA',
}

interface ChartDataAction {
	type: CHARTS_DATA_ACTION_TYPES.GET_CHARTS_DATA
	payload: any
}

interface PainLevelChartData {
	type: CHARTS_DATA_ACTION_TYPES.GET_PAIN_LEVEL_CHART_DATA
	payload: any
}

export interface ChartItemData {
	activity_name?: string
	duration?: number
	energyburntvalue?: string
	event_group_id?: string
	event_time: number
	event_time_orig?: number
	event_type?: string
	id: string
	note: string
	parent_id?: string
	tags: string[]
	timezone?: number
	timezone_offset?: number
	glucosevalue?: string
}

export interface ChartsState {
	chartsData: Array<ChartItemData>
}

const initialState: any = {
	chartsData: [],
}

type chartsActions = ChartDataAction | PainLevelChartData

export default (state = initialState, action: chartsActions): ChartsState => {
	switch (action.type) {
		case CHARTS_DATA_ACTION_TYPES.GET_CHARTS_DATA: {
			return {
				...state,
				chartsData: action.payload || [],
			}
		}
		case CHARTS_DATA_ACTION_TYPES.GET_PAIN_LEVEL_CHART_DATA: {
			action.payload.forEach(
				(data: any) =>
					(data.dt = `${new Date(data.dt).getDate()}/${
						new Date(data.dt).getMonth() + 1
					}`)
			)
			return {
				...state,
				chartsData: action.payload || [],
			}
		}

		default: {
			return state
		}
	}
}
